const Newsletter = () => {
  return (
    <section className="section container" id="contacto">
      <div className="newsletter-box">
        <div>
          <span className="newsletter-kicker">Boletín y contacto</span>
          <h2>Recibe ofertas, novedades y recordatorios de nuevas colecciones.</h2>
          <p>
            Este formulario está listo para después conectarlo con un endpoint real, Mailchimp,
            Brevo o cualquier servicio que uses.
          </p>
        </div>

        <form className="newsletter-form">
          <input type="text" placeholder="Nombre" />
          <input type="email" placeholder="Correo electrónico" />
          <button type="submit">Suscribirme</button>
        </form>
      </div>
    </section>
  );
};

export default Newsletter;
